// src/app/App.jsx
import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
// MUI DATE PICKER
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';
//import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { ko } from 'date-fns/locale';
// ALL CONTEXT FILES
// import { AuthProvider } from "app/contexts/FirebaseAuthContext";
import { AuthProvider } from "app/contexts/JWTAuthContext";
import { SettingsProvider } from "app/contexts/SettingsContext";
// THEME PROVIDER
import { ExpTheme } from "./components/ExpTheme";
// REDUX STORE
import store from "./redux/store";
// ALL ROUTES
import routes from "./routes";
import { ExamTypeProvider } from './contexts/ExamTypeContext';
import { UserProvider } from './contexts/UserContext';
// MAINTENANCE WRAPPER
import MaintenanceWrapper from './components/MaintenanceWrapper';

export default function App() {
  const content = useRoutes(routes);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
      <Provider store={store}>
        <SettingsProvider>
          <ExpTheme>
            <AuthProvider>
              <ExamTypeProvider>
                <UserProvider>
                  <MaintenanceWrapper>
                    {content}
                  </MaintenanceWrapper>
                </UserProvider>
              </ExamTypeProvider>
            </AuthProvider>
          </ExpTheme>
        </SettingsProvider>
      </Provider>
    </LocalizationProvider>
  );
}
